import { render, staticRenderFns } from "./dateDocDueTerms.vue?vue&type=template&id=04a6aaf0&scoped=true"
import script from "./dateDocDueTerms.vue?vue&type=script&lang=js"
export * from "./dateDocDueTerms.vue?vue&type=script&lang=js"
import style0 from "./dateDocDueTerms.vue?vue&type=style&index=0&id=04a6aaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6aaf0",
  null
  
)

export default component.exports